module.exports = function (e) {
  var r = {};
  function t(o) {
    if (r[o]) return r[o].exports;
    var a = r[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
  }
  return t.m = e, t.c = r, t.d = function (e, r, o) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: o
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (t.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var a in e) t.d(o, a, function (r) {
      return e[r];
    }.bind(null, a));
    return o;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 1);
}([function (e, r) {
  e.exports = require("react");
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var o = function () {
      function e(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      return function (r, t, o) {
        return t && e(r.prototype, t), o && e(r, o), r;
      };
    }(),
    a = i(t(0)),
    l = t(2),
    n = i(t(3));
  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function s(e, r) {
    if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
  }
  function u(e, r) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !r || "object" != typeof r && "function" != typeof r ? e : r;
  }
  var p,
    d,
    c,
    f = function (e) {
      function r() {
        return s(this, r), u(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments));
      }
      return function (e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function, not " + typeof r);
        e.prototype = Object.create(r && r.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
      }(r, e), o(r, [{
        key: "render",
        value: function () {
          var e = this.props,
            r = e.onClick,
            t = e.size,
            o = e.ariaLabel,
            i = e.activeBgColor,
            s = e.activeBorderColor,
            u = e.disabledBgColor,
            p = e.disabledBorderColor,
            d = e.bgColor,
            c = e.borderColor,
            f = e.activeColor,
            b = e.color,
            C = e.disabledColor,
            x = e.circle,
            h = e.shadow,
            v = e.center,
            y = e.className,
            P = (0, l.getPagination)(this.props);
          return a.default.createElement("nav", {
            "aria-label": o,
            className: "row " + (v && "justify-content-center") + " " + (y && y)
          }, a.default.createElement("ul", {
            style: g(h, x),
            className: "pagination " + (("sm" === t || "lg" === t) && "pagination-" + t)
          }, P.map(function (e, o) {
            return a.default.createElement(n.default, {
              key: e + "-" + o,
              text: e.text,
              page: e.page,
              className: e.class,
              href: e.href,
              onClick: r,
              activeBgColor: i,
              activeBorderColor: s,
              disabledBgColor: u,
              disabledBorderColor: p,
              bgColor: d,
              borderColor: c,
              activeColor: f,
              color: b,
              disabledColor: C,
              circle: x,
              shadow: h,
              size: t
            });
          })));
        }
      }]), r;
    }(a.default.Component);
  r.default = f, f.propTypes = {
    totalPages: a.default.PropTypes.number.isRequired,
    currentPage: a.default.PropTypes.number.isRequired,
    ariaLabel: a.default.PropTypes.string,
    size: a.default.PropTypes.string,
    showMax: a.default.PropTypes.number,
    activeClass: a.default.PropTypes.string,
    defaultClass: a.default.PropTypes.string,
    disabledClass: a.default.PropTypes.string,
    threeDots: a.default.PropTypes.bool,
    href: a.default.PropTypes.string,
    pageOneHref: a.default.PropTypes.string,
    prevNext: a.default.PropTypes.bool,
    prevText: a.default.PropTypes.string,
    nextText: a.default.PropTypes.string,
    center: a.default.PropTypes.bool,
    onClick: a.default.PropTypes.func,
    activeBgColor: a.default.PropTypes.string,
    activeBorderColor: a.default.PropTypes.string,
    disabledBgColor: a.default.PropTypes.string,
    disabledBorderColor: a.default.PropTypes.string,
    bgColor: a.default.PropTypes.string,
    borderColor: a.default.PropTypes.string,
    activeColor: a.default.PropTypes.string,
    disabledColor: a.default.PropTypes.string,
    color: a.default.PropTypes.string,
    circle: a.default.PropTypes.bool,
    shadow: a.default.PropTypes.bool,
    className: a.default.PropTypes.string
  }, f.defaultProps = (c = !0, (d = "center") in (p = {
    currentPage: 1,
    ariaLabel: "Page navigator",
    activeClass: "active",
    disabledClass: "disabled",
    showMax: 5,
    center: !1,
    size: "md",
    prevNext: !0,
    prevText: "⟨",
    nextText: "⟩",
    circle: !1,
    shadow: !1
  }) ? Object.defineProperty(p, d, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : p[d] = c, p);
  var g = function (e, r) {
    return e ? r ? {} : {
      WebkitBoxShadow: "0 8px 17px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)",
      boxShadow: "0px 8px 17px 0px rgba(0,0,0,0.2),0px 6px 20px 0px rgba(0,0,0,0.19)"
    } : {};
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var o = function (e, r) {
      return r === e;
    },
    a = function (e, r) {
      var t = {
        page: !1,
        text: "...",
        isCurrent: !1,
        class: r.disabledClass
      };
      return 1 !== e[0].page && e.unshift(t) && e.unshift({
        page: 1,
        text: 1,
        isCurrent: !1,
        class: r.defaultClass,
        href: r.pageOneHref ? r.pageOneHref : r.href && r.href.replace("*", 1)
      }), e[e.length - 1].page !== r.totalPages && e.push(t) && e.push({
        page: r.totalPages,
        text: r.totalPages,
        isCurrent: !1,
        class: r.defaultClass,
        href: r.href && r.href.replace("*", r.totalPages)
      }), e;
    },
    l = function (e, r) {
      var t = {
        page: r.currentPage + 1,
        text: r.nextText,
        isCurrent: !1,
        class: r.currentPage + 1 > r.totalPages && r.disabledClass,
        href: r.href && r.href.replace("*", r.currentPage + 1)
      };
      return e.push(t), e;
    },
    n = function (e, r) {
      var t = {
        page: r.currentPage - 1,
        text: r.prevText,
        isCurrent: !1,
        class: r.currentPage - 1 < 1 && r.disabledClass,
        href: r.href && r.href.replace("*", r.currentPage - 1)
      };
      return e.unshift(t), e;
    };
  r.getPagination = function (e) {
    var r = [],
      t = e.currentPage - Math.floor(e.showMax / 2),
      i = function () {
        return Math.sign(t);
      };
    -1 !== i() && 0 !== i() && -0 !== i() || (t = 1);
    for (var s = e.showMax > e.totalPages ? e.totalPages : e.showMax, u = 0; u < s; u++) r.push({
      page: t + u,
      text: t + u,
      isCurrent: o(t + u, e.currentPage),
      class: o(t + u, e.currentPage) ? e.activeClass : e.defaultClass,
      href: t + u === 1 ? e.href && e.pageOneHref : e.href && e.href.replace("*", t + u)
    });
    return e.threeDots && (r = a(r, e)), e.prevNext && (r = l(r, e), r = n(r, e)), r;
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var o = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
      return e;
    },
    a = n(t(0)),
    l = n(t(4));
  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var i = function (e, r) {
      return e ? "lg" !== r && "sm" !== r ? {
        borderRadius: "30px",
        marginLeft: "6px",
        marginRight: "6px",
        width: "45px",
        height: "45px",
        padding: "11px"
      } : "lg" === r ? {
        borderRadius: "30px",
        marginLeft: "6px",
        marginRight: "6px",
        width: "57px",
        height: "57px",
        padding: ".75rem 17px"
      } : "sm" === r ? {
        borderRadius: "30px",
        marginLeft: "4px",
        marginRight: "4px",
        width: "36px",
        height: "36px",
        padding: "7px"
      } : void 0 : {};
    },
    s = function (e, r) {
      return e && r ? {
        WebkitBoxShadow: "0 8px 17px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)",
        boxShadow: "0px 8px 17px 0px rgba(0,0,0,0.2),0px 6px 20px 0px rgba(0,0,0,0.19)"
      } : {};
    };
  r.default = function (e) {
    var r = e.text,
      t = e.page,
      n = e.className,
      u = e.onClick,
      p = e.href,
      d = e.activeBgColor,
      c = e.activeBorderColor,
      f = e.disabledBgColor,
      g = e.disabledBorderColor,
      b = e.bgColor,
      C = e.borderColor,
      x = e.activeColor,
      h = e.disabledColor,
      v = e.color,
      y = e.circle,
      P = e.shadow,
      m = e.size;
    return a.default.createElement("li", {
      className: "page-item " + (void 0 !== n && !1 !== n ? n : "")
    }, a.default.createElement("a", o({
      style: o({}, (0, l.default)({
        activeBgColor: d,
        activeBorderColor: c,
        disabledBgColor: f,
        disabledBorderColor: g,
        bgColor: b,
        borderColor: C,
        activeColor: x,
        color: v,
        disabledColor: h
      }, n), i(y, m), s(P, y)),
      className: "page-link",
      onClick: function () {
        return u && u(t);
      }
    }, u ? {
      href: "#"
    } : {
      href: p
    }), r));
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  r.default = function (e, r) {
    switch (r) {
      case !1:
        return {
          color: e.color && e.color,
          backgroundColor: e.bgColor,
          borderColor: e.borderColor
        };
      case "disabled":
        return {
          color: e.disabledColor && e.disabledColor,
          backgroundColor: e.disabledBgColor ? e.disabledBgColor : e.bgColor,
          borderColor: e.disabledBorderColor ? e.disabledBorderColor : e.borderColor
        };
      case "active":
        return {
          color: e.activeColor && e.activeColor,
          backgroundColor: e.activeBgColor,
          borderColor: e.activeBorderColor
        };
    }
  };
}]);